import { FormProvider } from "react-hook-form";

import { DialogContent } from "@/view/components/ui/dialog";
import AddressForm from "./components/AddressForm";
import BankInfoForm from "./components/BankInfoForm";
import PersonalInfoForm from "./components/PersonalInfoForm";
import ReferencesForm from "./components/ReferencesForm";
import ReviewProposal from "./components/ReviewProposal";
import SentProposal from "./components/SentProposal";
import Steps from "./components/Steps";
import useNewCrefazCltModal from "./useNewCrefazCltModal";

export default function NewCrefazCltModal() {
  const {
    form,
    step,
    steps,
    title,
    isSubmitting,
    submitProposal,
    contract,
    selectedOffer,
  } = useNewCrefazCltModal();

  return (
    <DialogContent
      className="flex max-h-[90vh] w-[95vw] max-w-3xl flex-col overflow-y-auto"
      onInteractOutside={(event) => {
        if (steps.sent) event.preventDefault();
      }}
    >
      {!steps.sent && (
        <>
          <h2 className="text-xl font-semibold text-black01">{title[step]}</h2>
          <Steps visible={!steps.sent} />
        </>
      )}

      <FormProvider {...form}>
        <PersonalInfoForm visible={steps.cliente} />
        <AddressForm visible={steps.endereco} />
        <ReferencesForm visible={steps.referencias} />
        <BankInfoForm visible={steps.bancario} />
        <ReviewProposal
          visible={steps.review}
          offer={selectedOffer}
          isSubmitting={isSubmitting}
          onSubmit={submitProposal}
        />
      </FormProvider>

      <SentProposal visible={steps.sent} contract={contract} />
    </DialogContent>
  );
}
